
import { mapGetters, mapState } from 'vuex'
import _ from 'lodash'
import { myInjectionKey } from '@/mixin/ds/keys'
import ProdUnitCmp from '@/components/ds/common/ProdUnitCmp.vue' // 상품유닛
import { commonfunc } from '~/mixin/common'
import * as exbt from '~/scriptData/ds/exbtCommon.js'

export default {
  name: 'ETCEXBT',
  components: {
    ProdUnitCmp
  },
  mixins: [commonfunc],
  inject: {
    injected: {
      default: null,
      from: myInjectionKey
    }
  },
  props: {
    lgCtgrNo: {
      type: String,
      default: ''
    },
    randomExbt: {
      type: Boolean,
      default: false
    },
    currentExbtNo: {
      type: String,
      default: ''
    },
    isLgCtgrPage: {
      type: Boolean,
      default: false
    }
  },
  asyncData () {},
  data () {
    return {
      currentPage: 1,
      contents: [],
      exbtList: [],
      planProdList: []
    }
  },
  fetch () {},
  computed: {
    exhCnrId: function () {
      return this.injected?.exhCnrId
    },
    plainList: function () {
      return this.exbtList.map((item, idx) => {
        const videoItem = item?.mtrls?.find((item) => {
          return (
            item?.exhMtrlTyCd === '01' && _.head(_.head(item?.exhCmptmtMtrlDtl)?.details)?.mblVideoAtchFileUrl
          )
        })

        let nameItem = ''
        item?.mtrls?.find((item) => {
          if (item?.exhMtrlTyCd === '03' && _.head(item?.exhCmptmtMtrlDtl)?.find(detail => detail?.textTyCd === '20')?.textNm) {
            nameItem = _.head(item?.exhCmptmtMtrlDtl)?.find(detail => detail?.textTyCd === '20')?.textNm
            return true
          }
          return false
        })

        let descItem = ''
        item?.mtrls?.find((item) => {
          if (item?.exhMtrlTyCd === '03' && _.head(item?.exhCmptmtMtrlDtl)?.find(detail => detail?.textTyCd === '30')?.textNm) {
            descItem = _.head(item?.exhCmptmtMtrlDtl)?.find(detail => detail?.textTyCd === '30')?.textNm
            return true
          }
          return false
        })

        const thumbItem = item?.mtrls?.find((item) => {
          return (
            item?.exhMtrlTyCd === '01' && _.head(_.head(item?.exhCmptmtMtrlDtl)?.details)?.pcThmnlAtchFileUrl
          )
        })

        const iconItem = item?.mtrls?.find((item) => {
          return (
            item?.exhMtrlTyCd === '01' && _.head(_.head(item?.exhCmptmtMtrlDtl)?.details)?.pcomIconAtchFileUrl
          )
        })

        const eyebrowItem = {
          text: '',
          color: 'black'
        }

        item?.mtrls?.forEach((item) => {
          if (item?.exhMtrlTyCd === '03' && _.head(item?.exhCmptmtMtrlDtl)) {
            const detail = _.head(item?.exhCmptmtMtrlDtl)?.find(detail => detail?.textTyCd === '10')

            if (detail) {
              eyebrowItem.text = detail?.textNm
              eyebrowItem.color = detail?.textFontColorCd
            }
          }
        })
        // 상품형 구좌소재
        let goodsList = ''
        item?.mtrls?.find((item, idx) => {
          if (item?.exhMtrlTyCd === '02' && _.head(item?.exhCmptmtMtrlDtl)) {
            goodsList = _.head(item?.exhCmptmtMtrlDtl)?.details?.filter(item => item?.sleStsCd === '03')?.map((item2, idx2) => {
              return {
                id: idx + '_' + idx2,
                pdImgUrl: item2?.pdImgUrl,
                pdPrc: item2?.pdPrc,
                onlSclCd: item2?.onlSclCd,
                bestYn: item2?.bestYn,
                exhPdNm: item2?.exhPdNm,
                totOrQy: item2?.totOrQy,
                soldOutYn: item2?.soldOutYn,
                sleStsCd: item2?.sleStsCd,
                reviewNum: item2?.revwCnt, // 리뷰갯수
                avgStscVal: item2?.avgStscVal,
                emblm: item2?.emblem,
                pdCttsTy: item2?.pdCttsTy,
                // option: '오트밀 투톤 스토 블루 머그컵11111'
                // most: true
                rankFlag: '',
                buyLmtAgeCd: item2?.buyLmtAgeCd,
                bunYn: item2?.bunYn,
                pkupDdcatYn: item2?.pkupDdcatYn,
                newPdYn: item2?.newPdYn,
                onlyOnlYn: item2?.onlyOnlYn,
                pdTy: item2?.pdTy,
                pdNo: item2?.pdNo,
                pkgYn: item2?.pkgYn,
                pkgEpieceSleYn: item2?.pkgEpieceSleYn,
                strgyPdYn: item2?.strgyPdYn,
                STRGY_PD_YN: item2?.STRGY_PD_YN,
              }
            })
            return true
          }
          return false
        })
        return {
          id: idx,
          exbtNo: item?.exbtNo,
          topFlag: [{
            text: item?.exbtThmeNm,
            bgColor: item?.exbtThmeBgColorCd
          }],
          video: videoItem
            ? _.head(_.head(videoItem?.exhCmptmtMtrlDtl)?.details)?.pcVideoAtchFileUrl
            : null,
          thumb: iconItem
            ? _.head(_.head(iconItem?.exhCmptmtMtrlDtl)?.details)?.pcomIconAtchFileUrl
            : _.head(_.head(thumbItem?.exhCmptmtMtrlDtl)?.details)?.pcThmnlAtchFileUrl,
          eyebrow: eyebrowItem,
          subProd: goodsList,
          name: nameItem,
          desc: descItem.replace(/\n/ig, '<br>'),
          reviewNum: this.isNotEmpty(item?.inct) ? item?.inct : 0,
          exhStDtm: item?.exhStDtm,
          exhEdDtm: item?.exhEdDtm,
          sortOrdr: item?.sortOrdr
        }
      })
    },
    isCtgrExbt: function () {
      return this.isNotEmpty(this.lgCtgrNo)
    },
    exbtNoList: function () {
      return this.injected?.contentArr.map((item) => {
        return item.exbtNo
      })
    },
    ...mapGetters('ds', ['getMaterialInfo']),
    ...mapState('ds', ['storeCtNm'])
  },
  created () {
    const productObj = {}
    productObj.showRndBtn = true
    const exhCmptmtId = this.injected?.exhCmptmtId
    this.$store.commit('ds/setDsMaterials', { productObj, exhCmptmtId })
  },
  async mounted () {
    await this.setDefaultList()

    if (this.randomExbt) { // 기획전 상세 내 랜덤기획전
      this.setRandomList()
    }
    if (!this.randomExbt && !this.isCtgrExbt && this.exbtNoList.length === 0) { // 일반 기획전 정보 없을경우 list 비우기
      this.exbtList = []
    }

    this.settingOrgList()
    this.exbtList.sort((a, b) => { return a.sortOrdr - b.sortOrdr })
  },
  methods: {
    async setDefaultList () {
      console.log('1. exbtNoList : ')
      console.log(this.exbtNoList)
      const exbtList = await this.$api.post('/ds/exbt/selExbt', { exbtThmeNm: '', exbtListExprYn: 'Y', exhCtgrNo: this.lgCtgrNo === 'CTGR_00001' ? '' : this.lgCtgrNo, exbtNos: this.isNotEmpty(this.exbtNoList) ? this.exbtNoList : [] })
        .then((res) => {
          if (res.data.success) {
            return res.data.data.filter((item) => { return item.aplMdiaPcomYn === 'Y' })
          }
        })

      this.injected?.contentArr.forEach((item) => {
        exbtList.forEach((mtrl) => {
          if (item.exbtNo === mtrl.exbtNo) {
            mtrl.sortOrdr = item.sortOrdr
          }
        })
      })
      this.exbtList = await exbt.getExbtMtrlsList(exbtList, this.$api)
    },
    setRandomList () {
      const shuffledList = _.shuffle(this.plainList)?.filter(item => item?.exbtNo !== this.currentExbtNo)
      this.planProdList = shuffledList.slice(0, 3)
    },
    settingOrgList () {
      this.plainList.sort((a, b) => { return a.sortOrdr - b.sortOrdr })
      if (this.isCtgrExbt) { // 1. 대카테고리 내 인기 기획전 : 상품형기획전 - 상품쪽은 숨김처리 / 콘텐츠형기획전 - 그대로 노출
        this.planProdList = _.map(this.plainList, ({ subProd, ...rest }) => rest)
      } else if (this.randomExbt) { // 2. 기획전 상세 내 랜덤기획전 : 상품+콘텐츠기획전 3개 갯수제한
        const shuffledList = _.shuffle(this.plainList)?.filter(item => item?.exbtNo !== this.currentExbtNo)
        this.planProdList = shuffledList.slice(0, 3)
      } else { // 3. 일반 기획전
        this.planProdList = this.plainList
      }
    }
  }
}
